import { initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _HttpMethod___init__impl__m4ft2w(asString) {
  return asString;
}
function _get_asString__9u9kco($this) {
  return $this;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.GET_1 = _HttpMethod___init__impl__m4ft2w('GET');
        this.POST_1 = _HttpMethod___init__impl__m4ft2w('POST');
        this.PUT_1 = _HttpMethod___init__impl__m4ft2w('PUT');
        this.PATCH_1 = _HttpMethod___init__impl__m4ft2w('PATCH');
        this.DELETE_1 = _HttpMethod___init__impl__m4ft2w('DELETE');
        this.OPTIONS_1 = _HttpMethod___init__impl__m4ft2w('OPTIONS');
        this.HEAD_1 = _HttpMethod___init__impl__m4ft2w('HEAD');
        this.WEBSOCKET_1 = _HttpMethod___init__impl__m4ft2w('WEBSOCKET');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function HttpMethod__toString_impl_hhk5hk($this) {
  return _get_asString__9u9kco($this);
}
//region block: exports
export {
  HttpMethod__toString_impl_hhk5hk as HttpMethod__toString_impl_hhk5hkow7sfhij4zpj,
  Companion_getInstance as Companion_getInstancel4ymxmn2l08f,
};
//endregion

//# sourceMappingURL=HttpMethod.mjs.map
